import { Fragment, useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import "./doubtsView.scss";
import { isEmpty } from "../../../../../custom_utilities/custom_useful_functions";
import Usercreatedoubt from "../../../user_create_doubt/user_create_doubt";
import { backGroundColorFromBackend } from "../../../../../custom_utilities/custom_useful_functions";
import NoDoubt from "./no_doubts/NoDoubt";
import AnsweredDoubtItem from "./answered_doubts/AnsweredDoubtItem";
import UnAnsweredDoubtItem from "./unanswered_doubts/UnAnsweredDoubtItem";
import ScannedDoubtItem from "./scanned_doubts/ScannedDoubtItem";
import CreateDoubtModal from "./modals/CreateDoubtModal";
import DoubtDetailModal from "./modals/DoubtDetailModal";
import ScannedDoubtDetailsView from "../doubtDetailsView/ScannedDoubtDetailsView";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { url_269 } from "../../../../../custom_utilities/api_services";
import axios from "axios";
import { connect } from "react-redux";
import uiActions from "../../../../../redux/ui/action";
import TutorHistory from "./tutor_history/TutorHistory";
import CreateNewDoubtBtn from "./buttons/CreateNewDoubtBtn";

const DoubtsView = ({
  subjectCollection: subjectCollectionProp, // Rename the prop to avoid confusion
  answeredDoubts,
  scannedDoubts,
  unAnsweredDoubts,
  subjectDetails,
  handleCreateDoubtBtn,
  handleChangeSubject,
  handleTabChange,
  handleSaveDoubtDetails,
  selectedDetail,
  getQuestionList,
  doubtType,
  historyType,
  userData,
  startLoading,
  finishLoading,
}) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [show, setShow] = useState(false);
  const [selected, setSelected] = useState(null);
  const [showDbtDetail, setShowDbtDetail] = useState(false);
  const [showScannedDbtDetail, setShowScannedDbtDetail] = useState(false);
  const [filoUserHistory, setFiloUserHistory] = useState(null);
  const [error, setError] = useState(null);
  const [deduplicatedSubjectCollection, setDeduplicatedSubjectCollection] =
    useState({ subject: [] });

  // Deduplicate subjectCollection when the prop changes
  useEffect(() => {
    if (
      !isEmpty(subjectCollectionProp) &&
      subjectCollectionProp.subject?.length
    ) {
      const uniqueSubjects = [
        ...new Map(
          subjectCollectionProp.subject.map((item) => [item.sub_id, item])
        ).values(),
      ];
      setDeduplicatedSubjectCollection({ subject: uniqueSubjects });
    } else {
      setDeduplicatedSubjectCollection({ subject: [] });
    }
  }, [subjectCollectionProp]);

  const handClick = (el) => {
    setSelected(el);
    setShowDbtDetail(true);
  };

  const handleScannedClick = (el) => {
    setSelected(el);
    setShowScannedDbtDetail(true);
  };

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleDtlClose = () => setShowDbtDetail(false);
  const handleScannedDtlClose = () => setShowScannedDbtDetail(false);

  // Custom Arrow Components
  const PrevArrow = (props) => {
    const { className, style, onClick } = props;
    return (
      <FaArrowLeft
        className={className}
        style={{
          ...style,
          display: currentSlide > 0 ? "block" : "none",
          borderRadius: "50%",
        }}
        onClick={onClick}
      />
    );
  };

  const NextArrow = (props) => {
    const { className, style, onClick } = props;
    return (
      <FaArrowRight
        className={className}
        style={{
          ...style,
          display: "block",
          borderRadius: "50%",
        }}
        onClick={onClick}
      />
    );
  };

  const renderSubjectCollection = (subjectCollection) => {
    const settings = {
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: true,
      prevArrow: <PrevArrow />,
      nextArrow: <NextArrow />,
      responsive: [
        {
          breakpoint: 2560,
          settings: {
            slidesToShow: 4,
          },
        },
        {
          breakpoint: 1440,
          settings: {
            slidesToShow: 4,
          },
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 991.98,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 575.98,
          settings: {
            slidesToShow: 2,
          },
        },
      ],
      centerPadding: "0px",
      afterChange: (current) => setCurrentSlide(current),
    };

    return (
      <Fragment>
        <div className="doubts_subject_collection_wrapper">
          {!isEmpty(subjectCollection) && subjectCollection.subject?.length ? (
            <Slider {...settings}>
              {subjectCollection.subject.map((element, index) => (
                <div key={index} style={{ padding: "0 5px" }}>
                  <div className="doubts_single_select_subject">
                    <input
                      type="radio"
                      id={`subject_${element.sub_id}`}
                      name="subject"
                      value={element.sub_id}
                      checked={
                        element.sub_id === parseInt(subjectDetails.subjectId)
                      }
                      onChange={(event) =>
                        handleChangeSubject(
                          event,
                          element.sub_id,
                          element.sub_name,
                          element.icon
                        )
                      }
                    />
                    <label
                      htmlFor={`subject_${element.sub_id}`}
                      style={backGroundColorFromBackend(
                        element.sub_id === parseInt(subjectDetails.subjectId)
                          ? element.color_code
                          : null
                      )}
                    >
                      {element.sub_name}
                    </label>
                  </div>
                </div>
              ))}
            </Slider>
          ) : null}
        </div>
      </Fragment>
    );
  };

  const renderQuestion = (question) => {
    return <p dangerouslySetInnerHTML={{ __html: question }}></p>;
  };

  const convertDate = (inputDate) => {
    const date = new Date(inputDate);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = String(date.getFullYear()).slice(-2);
    return `${day}-${month}-${year}`;
  };

  const renderOverallBtn = () => {
    return (
      <div className="overall_create_new_doubt_btn">
        <CreateNewDoubtBtn handleShow={handleShow} userData={userData} />
      </div>
    );
  };

  const renderOverallCreateNewDoubtBtn = () => {
    if (historyType === "tutorSessionHistory") {
      if (
        !isEmpty(filoUserHistory) &&
        filoUserHistory?.full_response?.answers?.length
      ) {
        return renderOverallBtn();
      }
      return null; // Do not render button if no tutor session history data
    }

    switch (doubtType) {
      case "all":
        if (
          answeredDoubts?.SaveDouteQuestionlist?.data?.length > 0 ||
          unAnsweredDoubts?.SaveDouteQuestionlist?.data?.length > 0 ||
          scannedDoubts?.SaveDouteQuestionlist?.data?.length > 0
        ) {
          return renderOverallBtn();
        }
        return null;
      case "answered":
        if (answeredDoubts?.SaveDouteQuestionlist?.data?.length > 0) {
          return renderOverallBtn();
        }
        return null;
      case "unanswered":
        if (unAnsweredDoubts?.SaveDouteQuestionlist?.data?.length > 0) {
          return renderOverallBtn();
        }
        return null;
      case "scanned":
        if (scannedDoubts?.SaveDouteQuestionlist?.data?.length > 0) {
          return renderOverallBtn();
        }
        return null;
      default:
        return null;
    }
  };

  const renderDoubts = () => {
    const allDoubts = [
      ...(answeredDoubts?.SaveDouteQuestionlist?.data?.map((item) => ({
        ...item,
        type: "answered",
      })) || []),
      ...(unAnsweredDoubts?.SaveDouteQuestionlist?.data?.map((item) => ({
        ...item,
        type: "unanswered",
      })) || []),
      ...(scannedDoubts?.SaveDouteQuestionlist?.data?.map((item) => ({
        ...item,
        type: "scanned",
      })) || []),
    ].sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

    return (
      <Fragment>
        <div className="doubtsCollectionView_wrapper">
          <div className="doubtsCollectionView_inner_wrapper">
            <div className="section_wrapper">
              <div className="section_inner_wrapper">
                <div className="options_wrapper">
                  <ul
                    className="nav nav-pills custom_nav_pills"
                    id="pills-tab"
                    role="tablist"
                  >
                    <li
                      className="nav-item custom_nav_item"
                      role="presentation"
                    >
                      <button
                        className={`nav-link ${
                          historyType === "doubtHistory" ? "active" : ""
                        } custom_nav_link`}
                        id="pills-doubt-history-tab"
                        data-bs-toggle="pill"
                        data-bs-target="#pills-doubt-history"
                        type="button"
                        role="tab"
                        aria-controls="pills-doubt-history"
                        aria-selected={historyType === "doubtHistory"}
                        onClick={() => handleTabChange(1, "doubtHistory")}
                      >
                        Doubt History
                      </button>
                    </li>
                    {userData?.UsertargetDetail?.some((e) =>
                      [1, 2, 3].includes(e.target_id)
                    ) && (
                      <li
                        className="nav-item custom_nav_item"
                        role="presentation"
                      >
                        <button
                          className={`nav-link ${
                            historyType === "tutorSessionHistory"
                              ? "active"
                              : ""
                          } custom_nav_link`}
                          id="pills-tutor-session-history-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#pills-tutor-session-history"
                          type="button"
                          role="tab"
                          aria-controls="pills-tutor-session-history"
                          aria-selected={historyType === "tutorSessionHistory"}
                          onClick={() =>
                            handleTabChange(1, "tutorSessionHistory")
                          }
                        >
                          Tutor Session History
                        </button>
                      </li>
                    )}
                  </ul>
                  {historyType === "doubtHistory" && (
                    <ul
                      className="nav nav-pills custom_nav_pills"
                      id="pills-doubt-subtab"
                      role="tablist"
                    >
                      <li
                        className="nav-item custom_nav_item"
                        role="presentation"
                      >
                        <button
                          className={`nav-link ${
                            doubtType === "all" ? "active" : ""
                          } custom_nav_link1`}
                          id="pills-all-doubts-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#pills-all-doubts"
                          type="button"
                          role="tab"
                          aria-controls="pills-all-doubts"
                          aria-selected={doubtType === "all"}
                          onClick={() => handleTabChange(1, "all")}
                        >
                          All
                        </button>
                      </li>
                      <li
                        className="nav-item custom_nav_item"
                        role="presentation"
                      >
                        <button
                          className={`nav-link ${
                            doubtType === "answered" ? "active" : ""
                          } custom_nav_link1`}
                          id="pills-answered-doubts-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#pills-answered-doubts"
                          type="button"
                          role="tab"
                          aria-controls="pills-answered-doubts"
                          aria-selected={doubtType === "answered"}
                          onClick={() => handleTabChange(0, "answered")}
                        >
                          Answered
                        </button>
                      </li>
                      <li
                        className="nav-item custom_nav_item"
                        role="presentation"
                      >
                        <button
                          className={`nav-link ${
                            doubtType === "unanswered" ? "active" : ""
                          } custom_nav_link1`}
                          id="pills-unanswered-doubts-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#pills-unanswered-doubts"
                          type="button"
                          role="tab"
                          aria-controls="pills-unanswered-doubts"
                          aria-selected={doubtType === "unanswered"}
                          onClick={() => handleTabChange(0, "unanswered")}
                        >
                          Unanswered
                        </button>
                      </li>
                      <li
                        className="nav-item custom_nav_item"
                        role="presentation"
                      >
                        <button
                          className={`nav-link ${
                            doubtType === "scanned" ? "active" : ""
                          } custom_nav_link1`}
                          id="pills-scanned-doubts-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#pills-scanned-doubts"
                          type="button"
                          role="tab"
                          aria-controls="pills-scanned-doubts"
                          aria-selected={doubtType === "scanned"}
                          onClick={() => handleTabChange(0, "scanned")}
                        >
                          Scanned
                        </button>
                      </li>
                    </ul>
                  )}
                </div>
                <div className="tab_wrapper">
                  <div
                    className="tab-content custom_tab_content"
                    id="pills-tabContent"
                  >
                    <div
                      className="tab-pane fade show active custom_tab_pane"
                      id="pills-doubt-history"
                      role="tabpanel"
                      aria-labelledby="pills-doubt-history-tab"
                    >
                      <div
                        className="tab-content custom_tab_content"
                        id="pills-doubt-subtabContent"
                      >
                        <div
                          className="tab-pane fade show active custom_tab_pane"
                          id="pills-all-doubts"
                          role="tabpanel"
                          aria-labelledby="pills-all-doubts-tab"
                        >
                          <div className="doubts_tab_wrapper">
                            <div className="outer_content_wrapper">
                              <div className="doubts_collection_wrapper">
                                {allDoubts.length > 0 ? (
                                  allDoubts.map((element, index) => {
                                    if (element.type === "answered") {
                                      return (
                                        <AnsweredDoubtItem
                                          key={index}
                                          element={element}
                                          index={index}
                                          handClick={handClick}
                                          convertDate={convertDate}
                                          renderQuestion={renderQuestion}
                                        />
                                      );
                                    } else if (element.type === "unanswered") {
                                      return (
                                        <UnAnsweredDoubtItem
                                          key={index}
                                          element={element}
                                          index={index}
                                          handClick={handClick}
                                          convertDate={convertDate}
                                          renderQuestion={renderQuestion}
                                        />
                                      );
                                    } else if (element.type === "scanned") {
                                      return (
                                        <ScannedDoubtItem
                                          key={index}
                                          element={element}
                                          index={index}
                                          handClick={handleScannedClick}
                                          convertDate={convertDate}
                                          renderQuestion={renderQuestion}
                                        />
                                      );
                                    }
                                    return null;
                                  })
                                ) : (
                                  <NoDoubt
                                    handleShow={handleShow}
                                    message="You haven't uploaded any doubts yet."
                                  />
                                )}
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          className="tab-pane fade custom_tab_pane"
                          id="pills-answered-doubts"
                          role="tabpanel"
                          aria-labelledby="pills-answered-doubts-tab"
                        >
                          <div className="doubts_tab_wrapper">
                            <div className="outer_content_wrapper">
                              <div className="doubts_collection_wrapper">
                                {!isEmpty(answeredDoubts) &&
                                answeredDoubts.SaveDouteQuestionlist.data
                                  .length ? (
                                  answeredDoubts.SaveDouteQuestionlist.data.map(
                                    (element, index) => (
                                      <AnsweredDoubtItem
                                        key={index}
                                        element={element}
                                        index={index}
                                        handClick={handClick}
                                        convertDate={convertDate}
                                        renderQuestion={renderQuestion}
                                      />
                                    )
                                  )
                                ) : (
                                  <NoDoubt
                                    handleShow={handleShow}
                                    message="You haven't uploaded any answered doubts yet."
                                  />
                                )}
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          className="tab-pane fade custom_tab_pane"
                          id="pills-unanswered-doubts"
                          role="tabpanel"
                          aria-labelledby="pills-unanswered-doubts-tab"
                        >
                          <div className="doubts_tab_wrapper">
                            <div className="outer_content_wrapper">
                              <div className="doubts_collection_wrapper">
                                {!isEmpty(unAnsweredDoubts) &&
                                unAnsweredDoubts.SaveDouteQuestionlist.data
                                  .length ? (
                                  unAnsweredDoubts.SaveDouteQuestionlist.data.map(
                                    (element, index) => (
                                      <UnAnsweredDoubtItem
                                        key={index}
                                        element={element}
                                        index={index}
                                        handClick={handClick}
                                        convertDate={convertDate}
                                        renderQuestion={renderQuestion}
                                      />
                                    )
                                  )
                                ) : (
                                  <NoDoubt
                                    handleShow={handleShow}
                                    message="You have no unanswered doubts."
                                  />
                                )}
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          className="tab-pane fade custom_tab_pane"
                          id="pills-scanned-doubts"
                          role="tabpanel"
                          aria-labelledby="pills-scanned-doubts-tab"
                        >
                          <div className="doubts_tab_wrapper">
                            <div className="outer_content_wrapper">
                              <div className="doubts_collection_wrapper">
                                {!isEmpty(scannedDoubts) &&
                                scannedDoubts.SaveDouteQuestionlist.data
                                  .length ? (
                                  scannedDoubts.SaveDouteQuestionlist.data.map(
                                    (element, index) => (
                                      <ScannedDoubtItem
                                        key={index}
                                        element={element}
                                        index={index}
                                        handClick={handleScannedClick}
                                        convertDate={convertDate}
                                        renderQuestion={renderQuestion}
                                      />
                                    )
                                  )
                                ) : (
                                  <NoDoubt
                                    handleShow={handleShow}
                                    message="You have not got an answer on your Doubts."
                                  />
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      className="tab-pane fade custom_tab_pane"
                      id="pills-tutor-session-history"
                      role="tabpanel"
                      aria-labelledby="pills-tutor-session-history-tab"
                    >
                      <div className="doubts_tab_wrapper">
                        <div className="outer_content_wrapper">
                          <div className="doubts_collection_wrapper">
                            {error ? (
                              <p className="error-message">{error}</p>
                            ) : !isEmpty(filoUserHistory) &&
                              filoUserHistory?.full_response?.answers
                                ?.length ? (
                              filoUserHistory.full_response.answers.map(
                                (element, index) => (
                                  <TutorHistory
                                    key={index}
                                    element={element}
                                    index={index}
                                    handClick={handleScannedClick}
                                    convertDate={convertDate}
                                    renderQuestion={renderQuestion}
                                  />
                                )
                              )
                            ) : (
                              <NoDoubt
                                handleShow={handleShow}
                                message="You have no tutor session history yet."
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <DoubtDetailModal
          showDbtDetail={showDbtDetail}
          handleDtlClose={handleDtlClose}
          doubtType={doubtType}
          selectedDoubt={selected}
          renderQuestion={renderQuestion}
          convertDate={convertDate}
        />

        <div className="douts_detailModal">
          <Modal
            show={showScannedDbtDetail}
            onHide={handleScannedDtlClose}
            className="view_douts_modal"
          >
            <Modal.Header closeButton></Modal.Header>
            <Modal.Body style={{ marginTop: "30px" }}>
              <ScannedDoubtDetailsView
                doubtDetails={selected}
                renderQuestion={renderQuestion}
                convertDate={convertDate}
                doubtType={doubtType}
              />
            </Modal.Body>
          </Modal>
        </div>
      </Fragment>
    );
  };

  useEffect(() => {
    if (!isEmpty(userData) && userData.user_id) {
      getFiloUserHistory();
    }
  }, [userData]);

  const getFiloUserHistory = async () => {
    const params = {
      user_id: userData?.user_id,
      subject: subjectDetails?.subjectName,
    };

    startLoading();

    try {
      const response = await axios.get(url_269, { params });

      if (response.status === 200) {
        setFiloUserHistory(response.data);
      } else {
        console.error("Failed to fetch Filo user history:", response.data);
        setError("Failed to fetch tutor session history.");
      }
    } catch (error) {
      console.error("Error fetching Filo user history:", error);
      setError("Error fetching tutor session history: " + error.message);
    } finally {
      finishLoading();
    }
  };

  useEffect(() => {}, [filoUserHistory]);

  return (
    <Fragment>
      <div className="doubtsView_wrapper">
        <div className="doubtsView_inner_wrapper">
          <div className="sec_2_wrapper">
            <div className="sec_2_inner_wrapper">
              <div className="content_wrapper">
                <div className="left_side_content_wrapper">
                  {renderSubjectCollection(deduplicatedSubjectCollection)}
                </div>
                <div className="right_side_content_wrapper">
                  {renderDoubts()}
                  <div className="sec_1_wrapper">
                    <CreateDoubtModal
                      show={show}
                      handleClose={handleClose}
                      Usercreatedoubt={Usercreatedoubt}
                      getQuestionList={getQuestionList}
                      subjectDetails={subjectDetails}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {renderOverallCreateNewDoubtBtn()}
      </div>
    </Fragment>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    startLoading: () => {
      dispatch(uiActions.startLoading());
    },
    finishLoading: () => {
      dispatch(uiActions.finishLoading());
    },
  };
};

export default connect(null, mapDispatchToProps)(DoubtsView);
